import React, { useEffect } from "react";
import styled from "styled-components";
import ReportTabs from "../../../components/AdminCentral/Reports/ReportTabs";
import ReportsContent from "../../../components/AdminCentral/Reports/ReportsContent";
import CertificationReports from "../../../components/AdminCentral/Reports/CertificationReports";
import ComplianceDocReport from "../../../components/AdminCentral/Reports/ComplianceDocReport";
import ERateCertReports from "../../../components/AdminCentral/Reports/ERateCertReports";
import OtherInternetSafety from "../../../components/AdminCentral/Reports/OtherInternetSafety";
import EducatorModuleDownloadReport from "../../../components/AdminCentral/Reports/EducatorModuleDownloadReport";
import usePersistentTabState from "../../../hooks/usePersistentTabState";

const breakpoints = {
  tablet: 768,
  phone:  480,
};


const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
`;

const Container = styled.div`
  width: 1100px;
  padding: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${({ colors }) => colors.cardBackground};
    @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
    padding: 16px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    width: 350px;
    padding: 12px;
  }
`;

const Title = styled.h1`
  font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px;
      @media (max-width: ${breakpoints.phone}px) {
    font-size: 1.5rem;
    text-align: left;
    margin-left: 20px;
    margin-bottom: 16px;
  }
`;

const REPORT_TABS = [
  "Compliance Doc Reports",
  "Certification Reports",
  "E-Rate Cert Reports",
  "Module Download Report",
  "Other Internet Safety",
];

export default function ReportPage({ colors }) {
  const [selectedTab, setSelectedTab] = usePersistentTabState(
    "admincentral.reports.selectedTab",
    null
  );

  useEffect(() => {
    if (selectedTab !== null && !REPORT_TABS.includes(selectedTab)) {
      setSelectedTab(null);
    }
  }, [selectedTab, setSelectedTab]);
  return (
    <DashboardContainer>
      <Title colors={colors}>Reports</Title>
      <Container colors={colors}>
        <ReportTabs
          colors={colors}
          selectedTab={selectedTab}
          handleTabClick={setSelectedTab}
        />

        {/* Default overview */}
        {selectedTab === null && (
          <ReportsContent
            colors={colors}
            onSelectTab={(tab) => setSelectedTab(tab)}
          />
        )}

        {selectedTab === "Compliance Doc Reports" && (
          <ComplianceDocReport colors={colors} />
        )}
        {selectedTab === "Certification Reports" && (
          <CertificationReports colors={colors} />
        )}
        {selectedTab === "E-Rate Cert Reports" && (
          <ERateCertReports colors={colors} />
        )}
        {selectedTab === "Module Download Report" && (
          <EducatorModuleDownloadReport colors={colors} />
        )}
        {selectedTab === "Other Internet Safety" && (
          <OtherInternetSafety colors={colors} />
        )}
      </Container>
    </DashboardContainer>
  );
}
